var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconBookStack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 71,
    height: 71,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_383_10912)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 5.2168,
    y: 61.085,
    width: 34.3721,
    height: 9.08128,
    fill: "#CE82FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16.3833,
    y: 37.3662,
    width: 37.3563,
    height: 10.8546,
    fill: "#ADE756"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3193 35.2337C13.3193 34.0562 14.2739 33.1016 15.4515 33.1016H53.0183V37.3659H15.4515C14.2739 37.3659 13.3193 36.4113 13.3193 35.2337Z",
    fill: "#78C800"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10.9497,
    y: 48.8682,
    width: 34.2091,
    height: 10.8546,
    fill: "#47D7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49268 46.7357C7.49268 45.5581 8.44728 44.6035 9.62485 44.6035H45.1589V48.8679H9.62485C8.44728 48.8679 7.49268 47.9133 7.49268 46.7357Z",
    fill: "#1CB0F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 42.7056,
    y: 44.6045,
    width: 24.9125,
    height: 12.5525,
    fill: "#1CB0F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 50.437,
    y: 33.1016,
    width: 17.181,
    height: 11.5019,
    fill: "#78C800"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.12793 58.9525C2.12793 57.7749 3.08254 56.8203 4.2601 56.8203H39.5889V61.0847H4.26011C3.08254 61.0847 2.12793 60.1301 2.12793 58.9525Z",
    fill: "#9069CD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.8022 4.73926L25.2254 8.1636",
    stroke: "#FFE600",
    strokeWidth: 3.50397,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0298 4.73926L54.6067 8.1636",
    stroke: "#FFE600",
    strokeWidth: 3.50397,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7354 23.8184L20.5442 27.0631",
    stroke: "#FFE600",
    strokeWidth: 3.50397,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.0967 23.8184L59.2878 27.0631",
    stroke: "#FFE600",
    strokeWidth: 3.50397,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.6401 15.7773L16.3833 15.8049",
    stroke: "#FFE600",
    strokeWidth: 3.50397,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.1914 15.7773L63.4482 15.8049",
    stroke: "#FFE600",
    strokeWidth: 3.50397,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.596 7.85437C40.2425 6.56621 42.0812 6.5662 42.7277 7.85437L44.4143 11.215C44.6692 11.723 45.1547 12.0757 45.7166 12.1612L49.434 12.7268C50.8589 12.9436 51.4271 14.6923 50.4018 15.7052L47.7268 18.3478C47.3225 18.7472 47.137 19.318 47.2293 19.8788L47.8402 23.589C48.0743 25.0112 46.5868 26.0919 45.3066 25.4298L41.9667 23.7023C41.4619 23.4412 40.8618 23.4412 40.357 23.7023L37.0171 25.4298C35.7369 26.0919 34.2494 25.0112 34.4835 23.589L35.0943 19.8788C35.1867 19.318 35.0012 18.7472 34.5969 18.3478L31.9219 15.7052C30.8966 14.6923 31.4647 12.9436 32.8896 12.7268L36.607 12.1612C37.1689 12.0757 37.6544 11.723 37.9094 11.215L39.596 7.85437Z",
    fill: "#FFE600"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 35.6821,
    y: 56.8203,
    width: 31.936,
    height: 13.3456,
    fill: "#9069CD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_383_10912"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "white",
    transform: "translate(0.0263672 0.0869141)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBookStack);
export default __webpack_public_path__ + "static/media/icon-book-stack.ac28fd9552408cdd2041f616f07ea842.svg";
export { ForwardRef as ReactComponent };